// External Imports
import { createSelector } from 'reselect';

// Internal Imports
import { CONTENT_ITEM_SINGLE } from '../config/types/path.js';
import { getPathType } from './getMatch.js';

// Local Functions
const getIsArticlePage = createSelector(
  getPathType,
  (pathType) => pathType === CONTENT_ITEM_SINGLE,
);

// Module Exports
export { getIsArticlePage };
